"use client"

import { usePathname } from "next/navigation";
import { ReactNode,useEffect } from "react";

import TopLoader from "../loader";
import { SmoothScrollProvider } from "../smooth-scroll-provider";
import { Footer } from "./footer";
import { NavbarMain } from "./navbar";

interface LayoutAppProps {
  children: ReactNode;
}

const LayoutApp = ({ children }: LayoutAppProps) => {

  const pathname = usePathname();

  useEffect(() => {
  const hash = window.location.hash;

  if (!hash) {
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }
}, [pathname]);

  return (
      <SmoothScrollProvider>
        <TopLoader /> 
        
        <NavbarMain />
        <main id="main-content min-h-screen">
          {children}
        </main>
        <Footer />
        
      </SmoothScrollProvider>
  );
};

export default LayoutApp;
